var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading || _setup.computedGroups.length)?_c(_setup.BenchmarkBarGroup,{attrs:{"title":"Workforce Impact","groups":_setup.computedGroups,"loading":_vm.loading}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }